<template>
  <div
    class="map-wrapper"
  >
    <template>
      <map-base
        class="eRegulation-map"
        ref="mapBase"
        :style="mapStyle"
        :map-options="mapOptions"
        @marker-zoom-updated="zoomLevel => $emit('set-history-switch-visible', zoomLevel > 14)"
        @markers:added="onAddedMarkers"
        @handleDragEndEvent="resetIcon"
      />
    </template>
  </div>
</template>
<script>
import MapBase from '@/global/components/map/MapBase.vue'
import L from 'leaflet'

const DIVIDE_BY_3 = 3
const DEFAULT_MARGINS = 12
const RESIZE_TIMEOUT_IN_MS = 200

export default {
  name: 'mainTableLeafletMap',

  components: {
    MapBase
  },

  props: {
    customComponentData: {
      type: String,
      default: null
    },
    tableColumnClass: {
      type: String,
      default: null
    },
    tableContainerClass: {
      type: String,
      default: null
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      resizeTimeoutId: null,
      initialMouseX: null,
      deltaX: 0,
      mapStyle: {
        zIndex: 0,
        flex: 1,
        borderRadius: '16px'
      },
      mapOptions: {
        renderer: L.canvas()
      }
    }
  },

  async mounted () {
    // Default preview is 1/3
    this.handle1Per3Preview()
    window.addEventListener('resize', this.handleBrowserResize)
    const { mapInitialized, queryParams } = this.config || {}

    if (typeof mapInitialized === 'function') {
      mapInitialized({
        map: this.$refs.mapBase || null,
        queryParams
      })
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleBrowserResize)
  },

  methods: {
    resetIcon (val) {
      const { resetIconOnMapDragEnd } = this.config || {}

      if (typeof resetIconOnMapDragEnd === 'function') {
        resetIconOnMapDragEnd({
          val
        })
      }
    },

    handleBrowserResize () {
      clearTimeout(this.resizeTimeoutId)

      this.resizeTimeoutId = setTimeout(() => {
        this.handle1Per3Preview()
      }, RESIZE_TIMEOUT_IN_MS)
    },

    handle1Per3Preview () {
      this.$nextTick(() => {
        const tableContainer = document.getElementsByClassName(this.tableContainerClass)
        const tableCol = document.getElementsByClassName(this.tableColumnClass)

        if (tableContainer && tableContainer[0] && tableContainer[0].clientWidth && tableCol && tableCol[0]) {
          const mapWidth = tableContainer[0].clientWidth / DIVIDE_BY_3
          const tableFullWidth = tableContainer[0].clientWidth

          tableCol[0].style.width = `${tableFullWidth - mapWidth - DEFAULT_MARGINS}px`
        }
      })
    },

    onAddedMarkers () {
      const { onAddedMarkers } = this.config || {}

      if (typeof onAddedMarkers === 'function') {
        onAddedMarkers()
      }
    }
  }
}
</script>

<style scoped>
.map-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
}

.eRegulation-map {
  .leaflet-marker-icon {
    background: unset !important;
    border: unset !important;
  }

  .custom-marker {
    width: 30px;
    height: 30px;
    border-radius: 50% 50% 50% 0;
    position: absolute;
    transform: rotate(-45deg);
    left: 50%;
    top: 50%;
    margin: -20px 0 0 -20px;
  }

  .custom-marker:after {
    content: "";
    width: 8px;
    height: 8px;
    margin: 11px 0 0 11px;
    background: #e6e6e6;
    position: absolute;
    border-radius: 50%;
  }

  /* Color variations */
  .green_icon { background-color: #28a745; }
  .blue_icon { background-color: #007bff; }
  .indigo_icon { background-color: #6610f2; }
  .orange_icon { background-color: #fd7e14; }
  .dark_orange_icon { background-color: #c75c00; }
  .purple_icon { background-color: #6f42c1; }
  .dark_purple_icon { background-color: #4b2c91; }
  .teal_icon { background-color: #20c997; }
  .dark_teal_icon { background-color: #158f6d; }
  .cyan_icon { background-color: #17a2b8; }
  .dark_cyan_icon { background-color: #0d5f6b; }
  .brown_icon { background-color: #795548; }
  .dark_brown_icon { background-color: #4e342e; }
  .lime_icon { background-color: #cddc39; }
  .dark_lime_icon { background-color: #afb42b; }
  .grey_icon { background-color: #6c757d; }
  .white_icon {
    background-color: #ffffff;
    border: 1px solid #ccc;
  }

  .selected {
    width: 37px;
    height: 37px;
    box-shadow: 0 0 10px 2px #696866;
  }

  .selected:after {
    margin: 15px 0 0 14px;
  }
}
</style>
